import React from "react";
import SideBar from "./SideBar";
import TopBar from "./TopBar";
import { useTranslation } from "react-i18next";
import { getCookie } from "../utils/Common";
import { fmtDay } from "./aces/Shared";

interface Props {
  mainLoading: boolean;
  billingList: any[];
  handleExportPDF: () => void;
  selectedMonth: string;
  months: string[];
  onPressMonth: (val: any) => void;
  onPayBillPressed: (val: any) => void;
}

const Billing = (props: Props) => {
  const { t } = useTranslation();
  const translatedMonths = t("common.months", {
    returnObjects: true,
  }) as string[];

  const cookie: any = getCookie("data");
  const role = cookie.role || null;

  return (
    <>
      <div className="__dashboard">
        <div className="__dashboard__wrapper">
          <SideBar />
          <div className="__dashboardRightSide">
            <TopBar />
            <div className="__dashboardContent">
              <div className="__pageHeading">{t("userTable.billing")}</div>
              <div className="__myTraining">
                <div className="billingTop">
                  <div className="statusSelec">
                    <span>{t("userTable.month")}</span>
                    <select
                      value={props.selectedMonth}
                      onChange={(e) => props.onPressMonth(e.target.value)}
                    >
                      {translatedMonths.map((month, index) => (
                        <option key={month} value={props.months[index]}>
                          {month}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="csv_pdf">
                    {props.billingList.length > 0 && (
                      <button
                        className="pdf_btn"
                        onClick={props.handleExportPDF}
                      >
                        {t("aces.payment.exportPdf")}
                      </button>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12 col-12">
                    <div className="__defaultTable" id="billing-table">
                      <table>
                        <thead>
                          <tr>
                            <th>{t("common.invoice_no")}</th>
                            <th>{t("userTable.userName")}</th>
                            <th>{t("userTable.completed")}</th>
                            <th>{t("userTable.totalBill")}</th>
                            <th>{t("userTable.status")}</th>
                            <th>{t("userTable.paidOn")}</th>
                            <th>{t("common.invoice_pdf")}</th>

                            {role !== "SUPER_ADMIN" && (
                              <th className="no-pdf">
                                {t("userTable.actions")}
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {props.billingList?.length > 0 ? (
                            props.billingList.map(
                              (item: any, index: number) => {
                                const user = item.user;
                                const bill = item.bill;

                                return (
                                  <tr key={index}>
                                    {/* Invoice No */}
                                    <td>qc{bill?.id}</td>

                                    {/* User Name */}
                                    <td>
                                      <div className="flex-gap">
                                        <div className="usernameIcon">
                                          {user?.name?.charAt(0) || "U"}
                                        </div>
                                        <div>
                                          <div>{user?.name || "N/A"}</div>
                                          <div className="text-muted small">
                                            {user?.email || "N/A"} |{" "}
                                            {user?.authProvider}
                                          </div>
                                        </div>
                                      </div>
                                    </td>

                                    {/* Completed Checklists */}
                                    <td>{bill?.checklistCount ?? "N/A"}</td>

                                    {/* Total Bill Amount */}
                                    <td>
                                      €{bill?.amount?.toFixed(2) ?? "0.00"}
                                    </td>

                                    {/* Paid/Unpaid Button */}
                                    <td>
                                      {bill?.isPaid ? (
                                        <button className="paid_btn">
                                          {t("common.paid")}
                                        </button>
                                      ) : (
                                        <button className="unpaid_btn">
                                          {t("common.unpaid")}
                                        </button>
                                      )}
                                    </td>

                                    {/* PaidOn or Unpaid */}
                                    <td
                                      className={
                                        bill?.isPaid ? "" : "redtdText"
                                      }
                                    >
                                      {bill?.isPaid && bill?.paidOn
                                        ? fmtDay(bill.paidOn)
                                        : t("aces.payment.unpaid")}
                                    </td>

                                    {/* pdf */}
                                    <td>
                                      {bill?.invoice ? (
                                        <a
                                          href={bill.invoice}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="text-primary"
                                        >
                                          {t("common.download_pdf")}
                                        </a>
                                      ) : (
                                        "N/A"
                                      )}
                                    </td>

                                    {/* Actions */}
                                    {role !== "SUPER_ADMIN" && (
                                      <td className="no-pdf">
                                        <div className="flex-gap">
                                          {!bill?.isPaid && (
                                            <button
                                              onClick={() =>
                                                props.onPayBillPressed(bill.id)
                                              }
                                              className="refund_btn"
                                            >
                                              {t("common.pay_bill")}
                                            </button>
                                          )}
                                          {bill?.isPaid && (
                                            <span className="text-success">
                                              <i className="ri-check-line"></i>{" "}
                                              {t("common.paid")}
                                            </span>
                                          )}
                                        </div>
                                      </td>
                                    )}
                                  </tr>
                                );
                              }
                            )
                          ) : (
                            <tr>
                              <td className="nofound" colSpan={8}>
                                {t("billing.no_data")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Billing;
